module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_pp1_8004.30313ef1.png";